import React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material"

function GradientCircularProgress() {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="loading" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#7495F8" />
            <stop offset="100%" stopColor="#0E2465" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress size={50} sx={{ "svg circle": { stroke: "url(#loading)" } }} />
    </React.Fragment>
  );
}

export const SimpleLoading = ({ open }) => (
  <Backdrop
    sx={{ 
      color: "#fff", 
      zIndex: (theme) => theme.zIndex.drawer + 1 }
    }
    open={open}
  >
    <Box     
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <GradientCircularProgress />
      <Typography variant="h6" mt={2}>
        Espere...
      </Typography>
    </Box>
  </Backdrop>
);

export const Loading = () => (
  <Box
    className="loading-content"
    width="100%"
    my={5}
  >
    <GradientCircularProgress />
    <Typography variant="h6" mt={2} sx={{ color: "#0E2465" }}>
      Cargando...
    </Typography>
  </Box>
)
